import React, { useEffect, useState } from 'react';
import { agentProductionTerms } from '../../../constants';
import { useAgentProfileStore } from '../../../store/store';
import HelixSegmentedControl from './HelixSegmentedControl';

export const tableChartModes = Object.freeze({ TABLE: 'table', CHART: 'chart' });

const TableChartToggle = ({ defaultMode, parentSetMode, mlsName }) => {
    const { setDisplayMode, displayMode } = useAgentProfileStore()
    const [mode, setMode] = useState(displayMode || defaultMode || tableChartModes.CHART);

    useEffect(() => {
        parentSetMode(mode);
        setDisplayMode(mode)
    }, [mode]);

    const handleModeClick = modeToSet => {
        setMode(modeToSet);
        parentSetMode(modeToSet);
    };

    const options = [
        { value: tableChartModes.CHART, label: agentProductionTerms.chart },
        { value: tableChartModes.TABLE, label: agentProductionTerms.table }
    ];

    return <div className="d-flex align-items-center">
        <span className='helix-body--strong mr-3'>{mlsName}</span>
        <HelixSegmentedControl
            setOption={handleModeClick}
            optionsList={options}
            defaultOption={mode}
        />
    </div>;
};

export default TableChartToggle;
